import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { BadgeAlt as Badge, Button, Card, CardContent, CardHeader, ScrollArea, Tabs, TabsContent, TabsList, TabsTrigger, Table, TableBody, TableCell, TableHead, TableHeader, TableRow, DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuTrigger, Select, SelectContent, SelectItem, SelectTrigger, SelectValue, Checkbox, Dialog, DialogContent, DialogHeader, DialogTitle, Switch, Popover, PopoverContent, PopoverTrigger, Tooltip, TooltipContent, TooltipProvider, TooltipTrigger, } from '@cargomatic/ui';
import { ChevronUp, ChevronDown, MoreVertical, AlertCircle, CheckCircle, X, Info, ChevronRight, Pencil, ExternalLink, Check, Trash2, } from 'lucide-react';
import { cn } from 'utils/ui/classes';
const vendorCharges = [
    {
        id: 1,
        charge: 'Dwell Fee',
        cost: 101.94,
        enteredDate: '11/14/2025 9:46 AM',
        paid: false,
        vendor: 'ITS International transportation services',
    },
];
const shipmentData = [
    { id: 'DAV-1292', amount: 0, billableStatus: 'awaiting_billable_event' },
    {
        id: 'DAV-1293',
        amount: 7.14,
        billableStatus: 'ready_to_bill',
        details: { carrierCost: 7.14 },
    },
    { id: 'DAV-1299', amount: 7.14, billableStatus: 'audited' },
];
const shipments = [
    {
        id: 'DAV-1292',
        status: 'en_route',
        billableStatus: 'awaiting_billable_event',
        legNumber: 1,
        legType: null, // Set to null
        equipmentId: '',
        pickup: 'Beverly Hills, CA 90210, USA',
        deliver: '5110 Telegraph Ave, Oakland, CA 94609, USA',
        carrier: '',
        deliveryOrder: '',
    },
    {
        id: 'DAV-1293',
        status: 'job_canceled',
        billableStatus: 'awaiting_billable_event',
        legNumber: 1,
        legType: null, // Set to null
        equipmentId: 'CONT-1234',
        pickup: 'Beverly Hills, CA 90210, USA',
        deliver: '5110 Telegraph Ave, Oakland, CA 94609, USA',
        carrier: 'Adam Driver',
        deliveryOrder: '',
    },
    {
        id: 'DAV-1299',
        status: 'arrived',
        billableStatus: 'awaiting_billable_event',
        legNumber: 1, // Changed from 2 to 1
        legType: null, // Set to null
        equipmentId: '',
        pickup: 'Beverly Hills, CA 90210, USA',
        deliver: '5110 Telegraph Ave, Oakland, CA 94609, USA',
        carrier: 'Adam Driver',
        deliveryOrder: '',
    },
];
const accessorialData = [
    {
        id: 1,
        shipment: 'DAV-1292',
        equipment: 'CONT-1234',
        name: 'Detention Fee',
        status: 'approved',
        billableStatus: 'invoiced',
        shipperRate: 150.0,
        carrierCost: 125.0,
        missingDocuments: false, // Added documents status
    },
    {
        id: 2,
        shipment: 'DAV-1293',
        equipment: 'CONT-1234',
        name: 'Fuel Surcharge',
        status: 'pending',
        billableStatus: 'pending_review',
        shipperRate: 75.5,
        carrierCost: 65.0,
        missingDocuments: true, // Added documents status
        missingDocumentsList: ['BOL', 'Delivery Receipt', 'Weight Ticket'], // Sample missing documents
    },
    {
        id: 3,
        shipment: 'DAV-1299',
        equipment: 'CONT-5678',
        name: 'Layover Fee',
        status: 'accepted',
        billableStatus: 'ready_to_bill',
        shipperRate: 200.0,
        carrierCost: 180.0,
        missingDocuments: false, // Added documents status
    },
    {
        id: 4,
        shipment: 'DAV-1292',
        equipment: 'CONT-1234',
        name: 'Chassis Fee',
        status: 'declined',
        billableStatus: 'billing_hold',
        shipperRate: 0.0,
        carrierCost: 0.0,
        missingDocuments: true, // Added documents status
        missingDocumentsList: ['Rate Confirmation'], // Sample missing documents
    },
    {
        id: 5,
        shipment: 'DAV-1293',
        equipment: 'CONT-1234',
        name: 'Storage Fee',
        status: 'pending-admin',
        billableStatus: 'audited',
        shipperRate: 95.0,
        carrierCost: 85.0,
        missingDocuments: false, // Added documents status
    },
];
const arCharges = [
    {
        id: 5,
        invoiceNumber: 'INV-ITG-16288208',
        billableStatus: 'invoiced',
        chargeName: 'Shipper cost',
        fee: 390.0,
        equipment: 'EQ12345',
        enteredDate: '11/07/2025 6:45 PM',
        rateSource: 'Manual',
        invoiceDate: '11/14/2025 4:15 PM',
        emailSent: true,
        ediSent: false,
        action: 'Shipper Cost Adjustment',
        reasonCode: '',
        notes: '',
        lastUser: 'admin@cargomatic.com',
    },
    {
        id: 6,
        invoiceNumber: 'INV-ITG-16288208',
        billableStatus: 'invoiced',
        chargeName: 'Fuel Surcharge',
        fee: 132.6,
        equipment: 'EQ12345',
        enteredDate: '11/10/2025 2:38 PM',
        rateSource: 'Manual',
        invoiceDate: '11/14/2025 4:15 PM',
        emailSent: true,
        ediSent: false,
        action: '', // Removed action to hide edit button for Fuel Surcharge
        reasonCode: '',
        notes: '',
        lastUser: 'm.delvalle@cargomatic.com',
    },
    {
        id: 1,
        invoiceNumber: '',
        shipmentId: 'DAV-1292',
        billableStatus: 'invoiced',
        chargeName: 'Detention Fee',
        fee: 150.0,
        equipment: 'CONT-1234',
        enteredDate: '11/11/2025 2:15 PM',
        rateSource: 'Automated',
        invoiceDate: '',
        emailSent: false,
        ediSent: false,
        action: '',
        reasonCode: '',
        notes: '', // Removed notes value
        lastUser: 'dgirlando@cargom',
    },
    {
        id: 2,
        invoiceNumber: '',
        shipmentId: 'DAV-1293',
        billableStatus: 'invoiced',
        chargeName: 'Fuel Surcharge',
        fee: 75.5,
        equipment: 'CONT-1234',
        enteredDate: '11/12/2025 9:00 AM',
        rateSource: 'Automated',
        invoiceDate: '',
        emailSent: false,
        ediSent: false,
        action: '',
        reasonCode: '',
        notes: '',
        lastUser: 'v.takale@cargomat',
    },
    {
        id: 3,
        invoiceNumber: '',
        shipmentId: 'DAV-1299',
        billableStatus: 'ready_to_bill',
        chargeName: 'Layover Fee',
        fee: 200.0,
        equipment: 'CONT-5678',
        enteredDate: '11/13/2025 4:45 PM',
        rateSource: 'Manual',
        invoiceDate: '',
        emailSent: false,
        ediSent: false,
        action: '',
        reasonCode: '',
        notes: '', // Removed notes value
        lastUser: 'dgirlando@cargom',
    },
    {
        id: 4,
        invoiceNumber: '',
        shipmentId: 'DAV-1293',
        billableStatus: 'audited',
        chargeName: 'Storage Fee',
        fee: 95.0,
        equipment: 'CONT-1234',
        enteredDate: '11/14/2025 11:20 AM',
        rateSource: 'Automated',
        invoiceDate: '',
        emailSent: false,
        ediSent: false,
        action: '',
        reasonCode: '',
        notes: '',
        lastUser: 'v.takale@cargomat',
    },
];
const apCharges = [
    {
        id: 6,
        billableStatus: 'ready_to_bill',
        chargeName: 'Carrier Cost', // Renamed from "Fuel Surcharge" to "Carrier Cost"
        fee: 250.0,
        equipment: 'EQ12345', // Added equipment number for Fuel Surcharge
        enteredDate: '11/07/2025\n11:25 AM',
        rateSource: 'Manual',
        chargeCode: 'Cc',
        chargeId: 'L0 c1 v5 xywfbp',
        payoutNumber: 'CMM-14587109',
        approvedPayout: 250.0,
        approvedPayoutDate: '11/16/2025\n12:20 AM',
        payoutStatus: 'Approved internally',
        paidDate: '11/08/2025',
    },
    // Shipment-level charges
    {
        id: 1,
        payoutNumber: 'CMM-14587109', // Added payout number
        shipmentId: 'DAV-1292',
        billableStatus: 'invoiced',
        chargeName: 'Detention Fee',
        fee: 125.0,
        equipment: 'CONT-1234', // Added equipment
        enteredDate: '11/03/2025\n2:15 PM',
        rateSource: 'Manual',
        chargeCode: 'Df',
        chargeId: 'L0 d1 v3 abcdef',
        approvedPayout: 125.0,
        approvedPayoutDate: '11/16/2025\n12:20 AM',
        payoutStatus: 'Approved internally',
        paidDate: '',
    },
    {
        id: 2,
        payoutNumber: 'CMM-14587109',
        shipmentId: 'DAV-1293',
        billableStatus: 'invoiced',
        chargeName: 'Fuel Surcharge',
        fee: 65.0,
        equipment: 'CONT-1234', // Added equipment
        enteredDate: '11/04/2025\n9:45 AM',
        rateSource: 'Automated',
        chargeCode: 'Fsc',
        chargeId: 'L0 f2 v4 ghijkl',
        approvedPayout: 65.0,
        approvedPayoutDate: '11/16/2025\n12:20 AM',
        payoutStatus: 'Approved internally',
        paidDate: '',
    },
    {
        id: 3,
        payoutNumber: '',
        shipmentId: 'DAV-1299',
        billableStatus: 'ready_to_bill',
        chargeName: 'Layover Fee',
        fee: 180.0,
        equipment: 'CONT-5678', // Added equipment
        enteredDate: '11/06/2025\n4:20 PM',
        rateSource: 'Manual',
        chargeCode: 'Lf',
        chargeId: 'L0 l3 v6 mnopqr',
        paidDate: '',
    },
    {
        id: 4,
        payoutNumber: '',
        shipmentId: 'DAV-1293',
        billableStatus: 'audited',
        chargeName: 'Storage Fee',
        fee: 85.0,
        equipment: 'CONT-1234', // Added equipment
        enteredDate: '11/02/2025\n1:10 PM',
        rateSource: 'Automated',
        chargeCode: 'Sf',
        chargeId: 'L0 s4 v2 stuvwx',
        paidDate: '',
    },
];
const auditHistory = [
    {
        name: 'Arrival date changed',
        change: 'Change: 2025-08-19T18:30:00.00Z',
        timestamp: 'August 19, 2025 11:15 PM',
        source: 'v.takale@cargomat',
    },
    {
        name: 'booked',
        timestamp: 'August 22, 2025 2:43 PM',
        source: 'dgirlando@cargom',
    },
    {
        name: 'Last free date changed',
        change: 'Change: 2025-08-28T18:30:00.00Z',
        timestamp: 'August 19, 2025 11:15 PM',
        source: 'v.takale@cargomat',
    },
    {
        name: 'Order Accepted',
        timestamp: 'August 19, 2025 4:12 PM',
        source: 'dgirlando@cargom',
    },
    {
        name: 'Order created',
        timestamp: 'August 19, 2025 4:12 PM',
        source: 'dgirlando@cargom',
    },
];
function getBillableStatusColor(status) {
    switch (status) {
        case 'invoiced':
        case 'audited':
            return 'bg-green-100 text-green-800 dark:bg-green-900 dark:text-green-200';
        case 'ready_to_bill':
            return 'bg-blue-100 text-blue-800 dark:bg-blue-900 dark:text-blue-200';
        case 'billing_hold':
        case 'incomplete':
            return 'bg-red-100 text-red-800 dark:bg-red-900 dark:text-red-200';
        case 'awaiting_billable_event':
        case 'pending_review':
        case 'template_billing':
        case 'customer_portal':
            return 'bg-gray-100 text-gray-800 dark:bg-gray-900 dark:text-gray-200';
        case 'supplemental_invoice':
            return 'bg-purple-100 text-purple-800 dark:bg-purple-900 dark:text-purple-200';
    }
}
function getBillableStatusLabel(status) {
    switch (status) {
        case 'awaiting_billable_event':
            return 'Awaiting Billable Event';
        case 'incomplete':
            return 'Incomplete';
        case 'ready_to_bill':
            return 'Ready to Bill';
        case 'audited':
            return 'Audited';
        case 'invoiced':
            return 'Invoiced';
        case 'supplemental_invoice':
            return 'Supplemental Invoice';
        case 'template_billing':
            return 'Template Billing';
        case 'customer_portal':
            return 'Customer Portal';
        case 'billing_hold':
            return 'Billing Hold';
        case 'pending_review':
            return 'Pending Review';
    }
}
function getAccessorialStatusColor(status) {
    switch (status) {
        case 'approved':
            return 'bg-green-100 text-green-800 dark:bg-green-900 dark:text-green-200';
        case 'accepted':
            return 'bg-blue-100 text-blue-800 dark:bg-blue-900 dark:text-blue-200';
        case 'pending':
            return 'bg-yellow-100 text-yellow-800 dark:bg-yellow-900 dark:text-yellow-200';
        case 'pending-admin':
            return 'bg-orange-100 text-orange-800 dark:bg-orange-900 dark:text-orange-200';
        case 'pending-shipper':
            return 'bg-amber-100 text-amber-800 dark:bg-amber-900 dark:text-amber-200';
        case 'declined':
            return 'bg-red-100 text-red-800 dark:bg-red-900 dark:text-red-200';
    }
}
function getAccessorialStatusLabel(status) {
    switch (status) {
        case 'pending':
            return 'Pending';
        case 'accepted':
            return 'Accepted';
        case 'approved':
            return 'Approved';
        case 'declined':
            return 'Declined';
        case 'pending-admin':
            return 'Pending Admin';
        case 'pending-shipper':
            return 'Pending Shipper';
    }
}
function getShipmentStatusColor(status) {
    switch (status) {
        case 'created':
        case 'en_route':
        case 'arrived':
        case 'scheduled':
        case 'exposed':
        case 'needs_appt':
        case 'accepted':
        case 'in_progress':
        case 'closed':
            return 'bg-green-100 text-green-800 dark:bg-green-900 dark:text-green-200';
        case 'job_canceled':
        case 'job_closed':
            return 'bg-gray-100 text-gray-800 dark:bg-gray-900 dark:text-gray-200';
        case 'canceled':
            return 'bg-red-100 text-red-800 dark:bg-red-900 dark:text-red-200';
    }
}
function getShipmentStatusLabel(status) {
    switch (status) {
        case 'created':
            return 'Created';
        case 'en_route':
            return 'En Route';
        case 'arrived':
            return 'Arrived';
        case 'scheduled':
            return 'Scheduled';
        case 'exposed':
            return 'Exposed';
        case 'needs_appt':
            return 'Needs Appt';
        case 'accepted':
            return 'Accepted';
        case 'in_progress':
            return 'In Progress';
        case 'job_canceled':
            return 'Job Canceled';
        case 'job_closed':
            return 'Job Closed';
        case 'canceled':
            return 'Canceled';
        case 'closed':
            return 'Closed';
    }
}
export default function FinancialManagementPage() {
    const [expandedAP, setExpandedAP] = useState('DAV-1293');
    const [isAccountingOpen, setIsAccountingOpen] = useState(true);
    const [isShipmentsOpen, setIsShipmentsOpen] = useState(true);
    const [isAuditOpen, setIsAuditOpen] = useState(true);
    const [equipmentModalOpen, setEquipmentModalOpen] = useState(false);
    const [selectedEquipment, setSelectedEquipment] = useState('');
    const [accessorialDrawerOpen, setAccessorialDrawerOpen] = useState(false);
    const [selectedAccessorial, setSelectedAccessorial] = useState(null);
    const [arFilter, setArFilter] = useState('all');
    const [selectedCharges, setSelectedCharges] = useState(new Set());
    const [apFilter, setApFilter] = useState('all');
    const [selectedAPCharges, setSelectedAPCharges] = useState(new Set());
    const [invoiceModalOpen, setInvoiceModalOpen] = useState(false);
    const [groupRelatedCharges, setGroupRelatedCharges] = useState(false);
    const [expandedSections, setExpandedSections] = useState(new Set(['shipper-cost', 'fuel-surcharge']));
    const [rerateModalOpen, setRerateModalOpen] = useState(false);
    const [rerateSelections, setRerateSelections] = useState({
        shipperBaseCost: false,
        carrierBaseCost: false,
        carrierFuelSurcharge: false,
        shipperFuelSurcharge: false,
    });
    const [pastDueEmailModalOpen, setPastDueEmailModalOpen] = useState(false);
    const [emailRecipients, setEmailRecipients] = useState('');
    const [showOptionalARColumns, setShowOptionalARColumns] = useState(false);
    const [shipperCostModalOpen, setShipperCostModalOpen] = useState(false);
    const [shipperCostValue, setShipperCostValue] = useState('390');
    const [shipperCostEquipment, setShipperCostEquipment] = useState('CMAU6148772');
    const [shipperCostReasonCode, setShipperCostReasonCode] = useState('');
    const [shipperCostNotes, setShipperCostNotes] = useState('');
    const [shipperCostErrors, setShipperCostErrors] = useState({
        reasonCode: false,
        notes: false,
    });
    const [accessorialFilter, setAccessorialFilter] = useState('pending');
    const [selectedShipment, setSelectedShipment] = useState(null);
    const totalInvoiced = arCharges
        .filter((charge) => !!charge.invoiceNumber)
        .reduce((sum, item) => sum + item.fee, 0);
    const totalAR = arCharges.reduce((sum, item) => sum + item.fee, 0);
    const totalAP = apCharges.reduce((sum, item) => sum + item.fee, 0);
    const totalAccessorials = accessorialData.reduce((sum, item) => sum + item.shipperRate, 0);
    const orderBillingStatus = 'incomplete';
    const grossProfit = 60.0;
    const grossMargin = 11.43;
    const unactionedPendingRevenue = 170.0;
    const unbilledApprovedRevenue = 120.0;
    const pendingAccessorialRevenue = 50.0;
    const unactionedPendingCOGS = 140.0;
    const filteredAccessorials = accessorialData.filter((acc) => {
        if (accessorialFilter === 'pending') {
            return (acc.status === 'pending' ||
                acc.status === 'pending-admin' ||
                acc.status === 'pending-shipper' ||
                acc.status === 'declined');
        }
        else {
            // approved
            return acc.status === 'approved' || acc.status === 'accepted';
        }
    });
    const filteredAccessorialsTotal = filteredAccessorials.reduce((sum, item) => sum + item.shipperRate, 0);
    const filteredCarrierAccessorialsTotal = filteredAccessorials.reduce((sum, item) => { var _a; return sum + ((_a = item.carrierCost) !== null && _a !== void 0 ? _a : 0); }, 0);
    const sortedARCharges = [...arCharges].sort((a, b) => {
        if (!a.shipmentId && b.shipmentId)
            return -1;
        if (a.shipmentId && !b.shipmentId)
            return 1;
        return 0;
    });
    const sortedAPCharges = [...apCharges].sort((a, b) => {
        if (!a.shipmentId && b.shipmentId)
            return -1;
        if (a.shipmentId && !b.shipmentId)
            return 1;
        return 0;
    });
    const filteredARCharges = sortedARCharges.filter((charge) => {
        const isActioned = !!charge.invoiceNumber;
        if (arFilter === 'actioned')
            return isActioned;
        if (arFilter === 'unactioned')
            return !isActioned;
        return true;
    });
    const filteredARTotal = filteredARCharges.reduce((sum, item) => sum + item.fee, 0);
    const allChargesActioned = sortedARCharges.every((charge) => !!charge.invoiceNumber);
    const filteredAPCharges = sortedAPCharges.filter((charge) => {
        const isActioned = !!charge.payoutNumber;
        if (apFilter === 'actioned')
            return isActioned;
        if (apFilter === 'unactioned')
            return !isActioned;
        return true;
    });
    const filteredAPTotal = filteredAPCharges.reduce((sum, item) => sum + item.fee, 0);
    const allAPChargesActioned = sortedAPCharges.every((charge) => !!charge.payoutNumber);
    const handleSelectCharge = (chargeId, checked) => {
        const newSelected = new Set(selectedCharges);
        if (checked) {
            newSelected.add(chargeId);
        }
        else {
            newSelected.delete(chargeId);
        }
        setSelectedCharges(new Set(newSelected));
    };
    const handleSelectAll = (checked) => {
        if (checked) {
            const unactionedIds = filteredARCharges
                .filter((charge) => !charge.invoiceNumber)
                .map((charge) => charge.id);
            setSelectedCharges(new Set(unactionedIds));
        }
        else {
            setSelectedCharges(new Set());
        }
    };
    const handleSelectAPCharge = (chargeId, checked) => {
        const newSelected = new Set(selectedAPCharges);
        if (checked) {
            newSelected.add(chargeId);
        }
        else {
            newSelected.delete(chargeId);
        }
        setSelectedAPCharges(new Set(newSelected));
    };
    const handleSelectAllAP = (checked) => {
        if (checked) {
            const unactionedIds = filteredAPCharges
                .filter((charge) => !charge.payoutNumber)
                .map((charge) => charge.id);
            setSelectedAPCharges(new Set(unactionedIds));
        }
        else {
            setSelectedAPCharges(new Set());
        }
    };
    const unactionedCharges = filteredARCharges.filter((charge) => !charge.invoiceNumber);
    const allUnactionedSelected = unactionedCharges.length > 0 &&
        unactionedCharges.every((charge) => selectedCharges.has(charge.id));
    const unactionedAPCharges = filteredAPCharges.filter((charge) => !charge.payoutNumber);
    const allUnactionedAPSelected = unactionedAPCharges.length > 0 &&
        unactionedAPCharges.every((charge) => selectedAPCharges.has(charge.id));
    const toggleSection = (sectionId) => {
        const newExpanded = new Set(expandedSections);
        if (newExpanded.has(sectionId)) {
            newExpanded.delete(sectionId);
        }
        else {
            newExpanded.add(sectionId);
        }
        setExpandedSections(new Set(newExpanded));
    };
    const getSelectedChargesData = () => {
        return arCharges.filter((charge) => selectedCharges.has(charge.id));
    };
    const getOrderLevelCharges = () => {
        const selected = getSelectedChargesData();
        return selected.filter((charge) => !charge.shipmentId);
    };
    const getShipmentLevelCharges = () => {
        const selected = getSelectedChargesData();
        return selected.filter((charge) => charge.shipmentId);
    };
    const getShipmentChargesByShipment = () => {
        const shipmentCharges = getShipmentLevelCharges();
        const grouped = {};
        shipmentCharges.forEach((charge) => {
            if (charge.shipmentId) {
                if (!grouped[charge.shipmentId]) {
                    grouped[charge.shipmentId] = [];
                }
                grouped[charge.shipmentId].push(charge);
            }
        });
        return grouped;
    };
    const calculateGrandTotal = () => {
        return getSelectedChargesData().reduce((sum, charge) => sum + charge.fee, 0);
    };
    return (React.createElement(TooltipProvider, null,
        React.createElement(Card, null,
            React.createElement(CardHeader, { className: "flex flex-row items-center justify-between cursor-pointer", onClick: () => setIsAccountingOpen(!isAccountingOpen) },
                React.createElement(ScrollArea, { className: "w-full" },
                    React.createElement("div", { className: "flex items-center justify-between gap-4 pb-2" },
                        React.createElement("div", { className: "flex items-center gap-2 whitespace-nowrap" },
                            isAccountingOpen ? (React.createElement(ChevronUp, { className: "h-5 w-5 flex-shrink-0" })) : (React.createElement(ChevronDown, { className: "h-5 w-5 flex-shrink-0" })),
                            React.createElement("h1", { className: "text-xl font-semibold" }, "Accounting"),
                            React.createElement(DropdownMenu, null,
                                React.createElement(DropdownMenuTrigger, { asChild: true, onClick: (e) => e.stopPropagation() },
                                    React.createElement(Button, { variant: "outline", size: "sm", className: "ml-2 bg-transparent" },
                                        "Actions",
                                        React.createElement(ChevronDown, { className: "ml-2 h-4 w-4" }))),
                                React.createElement(DropdownMenuContent, { align: "start", className: "w-56" },
                                    React.createElement(DropdownMenuItem, { onClick: (e) => {
                                            e.stopPropagation();
                                            setRerateModalOpen(true);
                                        } }, "Rerate Costs"),
                                    React.createElement(DropdownMenuItem, { onClick: (e) => {
                                            e.stopPropagation();
                                            setPastDueEmailModalOpen(true);
                                        } }, "Send Fees Past Due Email")))),
                        React.createElement("div", { className: "flex items-center gap-4 flex-shrink-0" },
                            React.createElement(Badge, { className: cn('text-sm whitespace-nowrap', getBillableStatusColor(orderBillingStatus)) }, "Billing Status: Incomplete"))))),
            isAccountingOpen && (React.createElement(CardContent, { className: "space-y-6" },
                React.createElement("div", { className: "space-y-4" },
                    React.createElement("div", { className: "flex gap-2 overflow-x-auto pb-2 scrollbar-thin" },
                        React.createElement(Card, { className: "border flex-shrink-0 min-w-[160px]" },
                            React.createElement(CardContent, { className: "pt-2 pb-1.5 px-3" },
                                React.createElement("div", { className: "text-xs text-muted-foreground font-medium mb-0.5" }, "Revenue"),
                                React.createElement("div", { className: "text-base font-bold" },
                                    "$",
                                    totalAR.toFixed(2)))),
                        React.createElement(Card, { className: "border flex-shrink-0 min-w-[160px]" },
                            React.createElement(CardContent, { className: "pt-2 pb-1.5 px-3" },
                                React.createElement("div", { className: "text-xs text-muted-foreground font-medium mb-0.5" }, "Carrier Costs"),
                                React.createElement("div", { className: "text-base font-bold" },
                                    "$",
                                    totalAP.toFixed(2)))),
                        React.createElement(Card, { className: "border flex-shrink-0 min-w-[160px]" },
                            React.createElement(CardContent, { className: "pt-2 pb-1.5 px-3" },
                                React.createElement("div", { className: "text-xs text-muted-foreground font-medium mb-0.5" }, "Vendor Costs"),
                                React.createElement("div", { className: "text-base font-bold" },
                                    "$",
                                    vendorCharges
                                        .reduce((sum, charge) => sum + charge.cost, 0)
                                        .toFixed(2)))),
                        React.createElement(Card, { className: "border flex-shrink-0 min-w-[160px]" },
                            React.createElement(CardContent, { className: "pt-2 pb-1.5 px-3" },
                                React.createElement("div", { className: "text-xs text-muted-foreground font-medium mb-0.5" }, "Gross Profit"),
                                React.createElement("div", { className: "text-base font-bold text-green-600" },
                                    "$",
                                    grossProfit.toFixed(2)))),
                        React.createElement(Card, { className: "border flex-shrink-0 min-w-[160px]" },
                            React.createElement(CardContent, { className: "pt-2 pb-1.5 px-3" },
                                React.createElement("div", { className: "text-xs text-muted-foreground font-medium mb-0.5" }, "Gross Margin"),
                                React.createElement("div", { className: "text-base font-bold text-green-600" },
                                    grossMargin.toFixed(2),
                                    "%"))),
                        React.createElement(Card, { className: "border flex-shrink-0 min-w-[160px]" },
                            React.createElement(CardContent, { className: "pt-2 pb-1.5 px-3" },
                                React.createElement("div", { className: "text-xs text-muted-foreground font-medium mb-0.5" }, "Unactioned Pending Revenue"),
                                React.createElement(Popover, null,
                                    React.createElement(PopoverTrigger, { asChild: true },
                                        React.createElement("button", { className: "text-base font-bold hover:text-blue-600 transition-colors underline decoration-dotted" },
                                            "$",
                                            unactionedPendingRevenue.toFixed(2))),
                                    React.createElement(PopoverContent, { className: "w-auto p-3", align: "start" },
                                        React.createElement("div", { className: "flex flex-col gap-2" },
                                            React.createElement("div", { className: "text-sm whitespace-nowrap" },
                                                React.createElement("span", { className: "font-medium" }, "Unbilled Approved Revenue:"),
                                                ' ',
                                                React.createElement("span", { className: "font-bold" },
                                                    "$",
                                                    unbilledApprovedRevenue.toFixed(2))),
                                            React.createElement("div", { className: "text-sm whitespace-nowrap" },
                                                React.createElement("span", { className: "font-medium" }, "Pending Accessorial Revenue:"),
                                                ' ',
                                                React.createElement("span", { className: "font-bold" },
                                                    "$",
                                                    pendingAccessorialRevenue.toFixed(2)))))))),
                        React.createElement(Card, { className: "border flex-shrink-0 min-w-[160px]" },
                            React.createElement(CardContent, { className: "pt-2 pb-1.5 px-3" },
                                React.createElement("div", { className: "text-xs text-muted-foreground font-medium mb-0.5" }, "Unactioned Pending COGS"),
                                React.createElement("div", { className: "text-base font-bold" },
                                    "$",
                                    unactionedPendingCOGS.toFixed(2)))))),
                React.createElement(Tabs, { defaultValue: "ar", className: "w-full" },
                    React.createElement(TabsList, { className: "grid w-full grid-cols-3" },
                        React.createElement(TabsTrigger, { value: "ar" }, "Accounts Receivable"),
                        React.createElement(TabsTrigger, { value: "ap" }, "Accounts Payable"),
                        React.createElement(TabsTrigger, { value: "amc" }, "Accessorial Management Center")),
                    React.createElement(TabsContent, { value: "amc", className: "mt-6" },
                        React.createElement("div", { className: "flex items-center justify-between mb-4" },
                            React.createElement("div", { className: "flex items-center gap-3" },
                                React.createElement("h2", { className: "text-lg font-semibold" }, "Accessorial Management Center"),
                                React.createElement(Select, { value: accessorialFilter, onValueChange: (value) => setAccessorialFilter(value) },
                                    React.createElement(SelectTrigger, { className: "w-[140px] h-9" },
                                        React.createElement(SelectValue, null)),
                                    React.createElement(SelectContent, null,
                                        React.createElement(SelectItem, { value: "pending" }, "Pending"),
                                        React.createElement(SelectItem, { value: "approved" }, "Approved")))),
                            React.createElement(Button, { variant: "outline", size: "sm", className: "text-green-600 border-green-600 hover:bg-green-50 bg-transparent whitespace-nowrap", onClick: (e) => e.stopPropagation() }, "Add Bulk Accessorials")),
                        React.createElement(Table, null,
                            React.createElement(TableHeader, null,
                                React.createElement(TableRow, null,
                                    React.createElement(TableHead, null, "Name"),
                                    React.createElement(TableHead, null, "Status"),
                                    React.createElement(TableHead, null, "Shipment"),
                                    React.createElement(TableHead, null, "Equipment"),
                                    React.createElement(TableHead, { className: "text-right" }, "Shipper Rate"),
                                    React.createElement(TableHead, { className: "text-right" }, "Carrier Cost"),
                                    React.createElement(TableHead, null, "Documents"),
                                    React.createElement(TableHead, null, "Actions"))),
                            React.createElement(TableBody, null,
                                filteredAccessorials.length > 0 ? (filteredAccessorials.map((accessorial) => {
                                    var _a;
                                    return (React.createElement(TableRow, { key: accessorial.id },
                                        React.createElement(TableCell, null,
                                            React.createElement("button", { onClick: () => {
                                                    setSelectedAccessorial(accessorial);
                                                    setAccessorialDrawerOpen(true);
                                                }, className: "text-blue-600 hover:underline" }, accessorial.name)),
                                        React.createElement(TableCell, null,
                                            React.createElement(Badge, { className: cn('text-xs', getAccessorialStatusColor(accessorial.status)) }, getAccessorialStatusLabel(accessorial.status))),
                                        React.createElement(TableCell, null,
                                            React.createElement(Link, { to: `/shipments/${accessorial.shipment}`, className: "text-blue-600 hover:underline" }, accessorial.shipment)),
                                        React.createElement(TableCell, null,
                                            React.createElement("button", { onClick: () => {
                                                    setSelectedEquipment(accessorial.equipment);
                                                    setEquipmentModalOpen(true);
                                                }, className: "text-blue-600 hover:underline" }, accessorial.equipment)),
                                        React.createElement(TableCell, { className: "text-right" },
                                            "$",
                                            accessorial.shipperRate.toFixed(2)),
                                        React.createElement(TableCell, { className: "text-right" },
                                            "$",
                                            accessorial.carrierCost.toFixed(2)),
                                        React.createElement(TableCell, null, accessorial.missingDocuments ? (React.createElement(TooltipProvider, null,
                                            React.createElement(Tooltip, null,
                                                React.createElement(TooltipTrigger, { asChild: true },
                                                    React.createElement(Badge, { className: "bg-red-100 text-red-800 dark:bg-red-900 dark:text-red-200 cursor-help" },
                                                        React.createElement(AlertCircle, { className: "h-3 w-3 mr-1" }),
                                                        "Missing")),
                                                React.createElement(TooltipContent, { side: "top", className: "max-w-xs" },
                                                    React.createElement("p", { className: "font-semibold mb-1" }, "Missing Documents:"),
                                                    React.createElement("ul", { className: "list-disc list-inside text-sm" }, ((_a = accessorial.missingDocumentsList) === null || _a === void 0 ? void 0 : _a.map((doc, index) => (React.createElement("li", { key: index }, doc)))) || React.createElement("li", null, "No details available")))))) : (React.createElement(Badge, { className: "bg-green-100 text-green-800 dark:bg-green-900 dark:text-green-200" },
                                            React.createElement(CheckCircle, { className: "h-3 w-3 mr-1" }),
                                            "Complete"))),
                                        React.createElement(TableCell, null,
                                            React.createElement(DropdownMenu, null,
                                                React.createElement(DropdownMenuTrigger, { asChild: true },
                                                    React.createElement(Button, { variant: "ghost", size: "sm", className: "h-8 w-8 p-0" },
                                                        React.createElement(MoreVertical, { className: "h-4 w-4" }))),
                                                React.createElement(DropdownMenuContent, { align: "end" },
                                                    React.createElement(DropdownMenuItem, { onClick: () => {
                                                            setSelectedAccessorial(accessorial);
                                                            setAccessorialDrawerOpen(true);
                                                        } }, "Edit"),
                                                    React.createElement(DropdownMenuItem, { onClick: () => {
                                                            console.log('[v0] Reversing accessorial:', accessorial.id);
                                                        } }, "Reverse"))))));
                                })) : (React.createElement(TableRow, null,
                                    React.createElement(TableCell, { colSpan: 8, className: "text-center text-muted-foreground" }, "No pending or declined accessorials"))),
                                filteredAccessorials.length > 0 && (React.createElement(TableRow, { className: "bg-muted/50 font-semibold" },
                                    React.createElement(TableCell, null, "Total"),
                                    React.createElement(TableCell, { colSpan: 3 }),
                                    React.createElement(TableCell, { className: "text-right" },
                                        "$",
                                        filteredAccessorialsTotal.toFixed(2)),
                                    React.createElement(TableCell, { className: "text-right" },
                                        "$",
                                        filteredCarrierAccessorialsTotal.toFixed(2)),
                                    React.createElement(TableCell, { colSpan: 2 })))))),
                    React.createElement(TabsContent, { value: "ar", className: "mt-6" },
                        React.createElement("div", { className: "flex items-center justify-between mb-4" },
                            React.createElement("div", { className: "flex items-center gap-4" },
                                React.createElement("h2", { className: "text-lg font-semibold" }, "Accounts Receivable"),
                                React.createElement(Select, { value: arFilter, onValueChange: (value) => setArFilter(value) },
                                    React.createElement(SelectTrigger, { className: "w-[220px]", onClick: (e) => e.stopPropagation() },
                                        React.createElement(SelectValue, null)),
                                    React.createElement(SelectContent, null,
                                        React.createElement(SelectItem, { value: "all" }, "Total Revenue"),
                                        React.createElement(SelectItem, { value: "actioned" }, "Invoiced"),
                                        React.createElement(SelectItem, { value: "unactioned" }, "Not-Invoiced")))),
                            React.createElement("div", { className: "flex items-center gap-4" },
                                React.createElement("div", { className: "flex flex-col items-end gap-1" },
                                    React.createElement(DropdownMenu, null,
                                        React.createElement(DropdownMenuTrigger, { asChild: true },
                                            React.createElement(Button, { variant: "outline", size: "sm", className: "text-green-600 border-green-600 hover:bg-green-50 bg-transparent whitespace-nowrap", disabled: allChargesActioned || selectedCharges.size === 0 },
                                                "Actions",
                                                React.createElement(ChevronRight, { className: "ml-1 h-4 w-4 rotate-90" }))),
                                        React.createElement(DropdownMenuContent, { align: "end" },
                                            React.createElement(DropdownMenuItem, { onClick: (e) => {
                                                    e.stopPropagation();
                                                    setInvoiceModalOpen(true);
                                                } }, "Create Invoice"),
                                            React.createElement(DropdownMenuItem, { onClick: (e) => {
                                                    e.stopPropagation();
                                                    // TODO: Implement bulk rerate functionality
                                                    console.log('Bulk rerate for charges:', Array.from(selectedCharges));
                                                } }, "Bulk Rerate"))),
                                    React.createElement(Popover, null,
                                        React.createElement(PopoverTrigger, { asChild: true },
                                            React.createElement("button", { className: "text-xs text-muted-foreground hover:text-foreground transition-colors underline decoration-dotted" }, "Invoice Configuration")),
                                        React.createElement(PopoverContent, { className: "w-auto p-3", align: "end" },
                                            React.createElement("div", { className: "flex flex-col gap-2" },
                                                React.createElement("div", { className: "bg-blue-50 dark:bg-blue-950 px-3 py-2 rounded text-sm text-blue-900 dark:text-blue-100 whitespace-nowrap" }, "Invoice Grouping: One per Shipment"),
                                                React.createElement("div", { className: "bg-purple-50 dark:bg-purple-950 px-3 py-2 rounded text-sm text-purple-900 dark:text-purple-100 whitespace-nowrap" }, "Pending Accessorial Billing Status Evaluation: Yes"))))))),
                        React.createElement("div", { className: "mb-4 -mt-3" },
                            React.createElement(Link, { to: "/shipper-rate-card", className: "text-xs text-blue-600 hover:underline" }, "Latest Shipper Rate Card")),
                        React.createElement("div", { className: "overflow-x-auto" },
                            React.createElement(Table, null,
                                React.createElement(TableHeader, null,
                                    React.createElement(TableRow, null,
                                        (arFilter === 'all' || arFilter === 'unactioned') &&
                                            !allChargesActioned && (React.createElement(TableHead, { className: "w-12" },
                                            React.createElement(Checkbox, { checked: allUnactionedSelected, onCheckedChange: handleSelectAll, disabled: unactionedCharges.length === 0 }))),
                                        React.createElement(TableHead, null, "Charge"),
                                        React.createElement(TableHead, null, "Cost"),
                                        React.createElement(TableHead, null, "Shipment"),
                                        React.createElement(TableHead, null, "Equipment"),
                                        React.createElement(TableHead, null, "Entered Date"),
                                        React.createElement(TableHead, null, "Rate Source"),
                                        React.createElement(TableHead, null, "Invoice"),
                                        React.createElement(TableHead, null, "Invoice Date"),
                                        showOptionalARColumns && (React.createElement(React.Fragment, null,
                                            React.createElement(TableHead, null, "Email Sent"),
                                            React.createElement(TableHead, null, "EDI Sent"),
                                            React.createElement(TableHead, null, "Action"),
                                            React.createElement(TableHead, null, "Reason Code"),
                                            React.createElement(TableHead, null, "Notes"),
                                            React.createElement(TableHead, null, "Last User"))),
                                        React.createElement(TableHead, { className: "w-12" },
                                            React.createElement(Button, { variant: "ghost", size: "sm", className: "h-8 w-8 p-0", onClick: () => setShowOptionalARColumns(!showOptionalARColumns), title: showOptionalARColumns
                                                    ? 'Hide optional columns'
                                                    : 'Show optional columns' },
                                                React.createElement(ChevronRight, { className: cn('h-4 w-4 transition-transform', showOptionalARColumns && 'rotate-90') }))))),
                                React.createElement(TableBody, null,
                                    filteredARCharges.map((charge) => {
                                        const isUnactioned = !charge.invoiceNumber;
                                        return (React.createElement(TableRow, { key: charge.id },
                                            (arFilter === 'all' ||
                                                arFilter === 'unactioned') &&
                                                !allChargesActioned && (React.createElement(TableCell, null, isUnactioned ? (React.createElement(Checkbox, { checked: selectedCharges.has(charge.id), onCheckedChange: (checked) => handleSelectCharge(charge.id, checked) })) : (React.createElement("div", { className: "w-4" })))),
                                            React.createElement(TableCell, null,
                                                React.createElement("div", { className: "flex items-center gap-2" },
                                                    React.createElement(Tooltip, null,
                                                        React.createElement(TooltipTrigger, { asChild: true },
                                                            React.createElement("button", { className: "flex items-center gap-1 hover:text-muted-foreground" },
                                                                React.createElement("span", null, charge.chargeName),
                                                                React.createElement(Info, { className: "h-4 w-4 text-muted-foreground" }))),
                                                        React.createElement(TooltipContent, { side: "right", className: "bg-black text-white p-3" },
                                                            React.createElement("div", { className: "space-y-1" },
                                                                React.createElement("div", { className: "font-semibold" }, "Charge Code"),
                                                                React.createElement("div", { className: "text-sm" }, charge.chargeName === 'Shipper cost'
                                                                    ? 'Frt'
                                                                    : charge.chargeName ===
                                                                        'Fuel Surcharge'
                                                                        ? 'Fsc'
                                                                        : charge.chargeName ===
                                                                            'Detention Fee'
                                                                            ? 'Det'
                                                                            : charge.chargeName ===
                                                                                'Layover Fee'
                                                                                ? 'Lay'
                                                                                : charge.chargeName ===
                                                                                    'Storage Fee'
                                                                                    ? 'Stor'
                                                                                    : 'N/A'),
                                                                React.createElement("div", { className: "font-semibold mt-2" }, "Charge ID"),
                                                                React.createElement("div", { className: "text-sm" }, charge.chargeName === 'Shipper cost'
                                                                    ? 'L0 f1 v5 xywfbp'
                                                                    : `CH${charge.id}_${Date.now().toString(36)}`)))),
                                                    !charge.shipmentId && (React.createElement(Badge, { className: "bg-purple-100 text-purple-800 dark:bg-purple-900 dark:text-purple-200" }, "Order-Level")))),
                                            React.createElement(TableCell, { className: "font-medium" },
                                                "$",
                                                charge.fee.toFixed(2)),
                                            React.createElement(TableCell, null, charge.shipmentId ? (React.createElement(Link, { to: `/shipments/${charge.shipmentId}`, className: "text-blue-600 hover:underline" }, charge.shipmentId)) : ('-')),
                                            React.createElement(TableCell, null, charge.equipment ? (React.createElement("button", { onClick: () => {
                                                    setSelectedEquipment(charge.equipment);
                                                    setEquipmentModalOpen(true);
                                                }, className: "text-blue-600 hover:underline" }, charge.equipment)) : ('-')),
                                            React.createElement(TableCell, null, charge.enteredDate ? (React.createElement("div", { className: "flex flex-col text-sm" },
                                                React.createElement("span", null, charge.enteredDate.split(' ')[0]),
                                                React.createElement("span", null, charge.enteredDate
                                                    .split(' ')
                                                    .slice(1)
                                                    .join(' ')))) : ('-')),
                                            React.createElement(TableCell, null, charge.rateSource || '-'),
                                            React.createElement(TableCell, null, charge.invoiceNumber ? (React.createElement(Link, { to: `/invoices/${charge.invoiceNumber}`, className: "text-blue-600 hover:underline inline-flex items-center gap-1" },
                                                charge.invoiceNumber,
                                                React.createElement(ExternalLink, { className: "h-3 w-3" }))) : (React.createElement("span", { className: "text-muted-foreground" }, "-"))),
                                            React.createElement(TableCell, null, charge.invoiceDate ? (React.createElement("div", { className: "flex flex-col text-sm" },
                                                React.createElement("span", null, charge.invoiceDate.split(' ')[0]),
                                                React.createElement("span", null, charge.invoiceDate
                                                    .split(' ')
                                                    .slice(1)
                                                    .join(' ')))) : ('-')),
                                            showOptionalARColumns && (React.createElement(React.Fragment, null,
                                                React.createElement(TableCell, null, charge.emailSent ? (React.createElement(Tooltip, null,
                                                    React.createElement(TooltipTrigger, { asChild: true },
                                                        React.createElement("div", { className: "flex items-center" },
                                                            React.createElement(CheckCircle, { className: "h-5 w-5 text-green-600" }))),
                                                    React.createElement(TooltipContent, { side: "top", className: "bg-black text-white px-3 py-2" }, "Email Sent!"))) : (React.createElement("span", { className: "text-muted-foreground" }, "-"))),
                                                React.createElement(TableCell, null, charge.ediSent ? (React.createElement(CheckCircle, { className: "h-5 w-5 text-green-600" })) : (React.createElement("span", { className: "text-muted-foreground" }, "-"))),
                                                React.createElement(TableCell, null, charge.action ? (React.createElement(Tooltip, null,
                                                    React.createElement(TooltipTrigger, { asChild: true },
                                                        React.createElement(Button, { variant: "ghost", size: "sm", className: "h-10 w-10 rounded-full bg-blue-100 hover:bg-blue-200 p-0", onClick: () => {
                                                                if (charge.chargeName ===
                                                                    'Shipper cost') {
                                                                    setShipperCostModalOpen(true);
                                                                }
                                                            } },
                                                            React.createElement(Pencil, { className: "h-4 w-4 text-blue-600" }))),
                                                    React.createElement(TooltipContent, { side: "top", className: "bg-black text-white px-3 py-2" }, charge.action))) : (React.createElement("span", { className: "text-muted-foreground" }, "-"))),
                                                React.createElement(TableCell, null, charge.reasonCode || '-'),
                                                React.createElement(TableCell, null, charge.notes || '-'),
                                                React.createElement(TableCell, { className: "text-sm text-muted-foreground" }, charge.lastUser || '-'))),
                                            React.createElement(TableCell, null)));
                                    }),
                                    React.createElement(TableRow, { className: "bg-muted/50 font-semibold" },
                                        (arFilter === 'all' || arFilter === 'unactioned') &&
                                            !allChargesActioned && React.createElement(TableCell, null),
                                        React.createElement(TableCell, null, "Total"),
                                        React.createElement(TableCell, null,
                                            "$",
                                            filteredARTotal.toFixed(2)),
                                        React.createElement(TableCell, { colSpan: showOptionalARColumns ? 13 : 7 })))))),
                    React.createElement(TabsContent, { value: "ap", className: "mt-6" },
                        React.createElement("div", { className: "flex items-center justify-between mb-4" },
                            React.createElement("div", { className: "flex items-center gap-4" },
                                React.createElement("h2", { className: "text-lg font-semibold" }, "Accounts Payable"),
                                React.createElement(Select, { value: apFilter, onValueChange: (value) => setApFilter(value) },
                                    React.createElement(SelectTrigger, { className: "w-[220px]", onClick: (e) => e.stopPropagation() },
                                        React.createElement(SelectValue, null)),
                                    React.createElement(SelectContent, null,
                                        React.createElement(SelectItem, { value: "all" }, "All Payables"),
                                        React.createElement(SelectItem, { value: "actioned" }, "Approved"),
                                        React.createElement(SelectItem, { value: "unactioned" }, "Un-Approved")))),
                            React.createElement("div", { className: "flex items-center gap-4" },
                                React.createElement(Button, { variant: "outline", size: "sm", className: "text-green-600 border-green-600 hover:bg-green-50 bg-transparent whitespace-nowrap", onClick: (e) => e.stopPropagation(), disabled: allAPChargesActioned || selectedAPCharges.size === 0 }, "Create Payout"))),
                        React.createElement("div", { className: "mb-4 -mt-3" },
                            React.createElement(Link, { to: "/carrier-rate-card", className: "text-xs text-blue-600 hover:underline" }, "Latest Carrier Rate Card")),
                        React.createElement(Table, null,
                            React.createElement(TableHeader, null,
                                React.createElement(TableRow, null,
                                    (apFilter === 'all' || apFilter === 'unactioned') &&
                                        !allAPChargesActioned && (React.createElement(TableHead, { className: "w-12" },
                                        React.createElement(Checkbox, { checked: allUnactionedAPSelected, onCheckedChange: handleSelectAllAP, disabled: unactionedAPCharges.length === 0 }))),
                                    React.createElement(TableHead, null, "Charge"),
                                    React.createElement(TableHead, { className: "text-right" }, "Cost"),
                                    React.createElement(TableHead, null, "Entered Date"),
                                    React.createElement(TableHead, null, "Rate Source"),
                                    React.createElement(TableHead, null, "Approved Payout"),
                                    React.createElement(TableHead, null, "Approved Payout Date"),
                                    React.createElement(TableHead, null, "Payout Status"),
                                    React.createElement(TableHead, null, "Paid Date"),
                                    React.createElement(TableHead, null, "Shipment"),
                                    React.createElement(TableHead, null, "Equipment"),
                                    React.createElement(TableHead, { className: "text-right" }, "Actions"))),
                            React.createElement(TableBody, null,
                                filteredAPCharges.map((charge) => {
                                    const isUnactioned = !charge.payoutNumber;
                                    return (React.createElement(TableRow, { key: charge.id },
                                        (apFilter === 'all' || apFilter === 'unactioned') &&
                                            !allAPChargesActioned && (React.createElement(TableCell, null, isUnactioned ? (React.createElement(Checkbox, { checked: selectedAPCharges.has(charge.id), onCheckedChange: (checked) => handleSelectAPCharge(charge.id, checked) })) : (React.createElement("div", { className: "w-4" })))),
                                        React.createElement(TableCell, null,
                                            React.createElement("div", { className: "flex items-center gap-2" },
                                                React.createElement(TooltipProvider, null,
                                                    React.createElement(Tooltip, null,
                                                        React.createElement(TooltipTrigger, { asChild: true },
                                                            React.createElement("button", { className: "flex items-center gap-1 hover:opacity-70" },
                                                                React.createElement("span", null, charge.chargeName),
                                                                React.createElement(Info, { className: "h-4 w-4 text-muted-foreground" }))),
                                                        React.createElement(TooltipContent, { side: "right", className: "bg-gray-900 text-white" },
                                                            React.createElement("div", { className: "space-y-1" },
                                                                React.createElement("p", { className: "font-semibold" }, "Charge Code"),
                                                                React.createElement("p", null, charge.chargeCode || 'N/A'),
                                                                React.createElement("p", { className: "font-semibold mt-2" }, "Charge ID"),
                                                                React.createElement("p", null, charge.chargeId || 'N/A'))))),
                                                !charge.shipmentId && (React.createElement(Badge, { className: "bg-purple-100 text-purple-800 dark:bg-purple-900 dark:text-purple-200" }, "Order-Level")))),
                                        React.createElement(TableCell, { className: "text-right font-medium" },
                                            "$",
                                            charge.fee.toFixed(2)),
                                        React.createElement(TableCell, null, charge.enteredDate ? (React.createElement("div", { className: "flex flex-col text-sm" }, charge.enteredDate
                                            .split('\n')
                                            .map((line, i) => (React.createElement("span", { key: i }, line))))) : (React.createElement("span", { className: "text-muted-foreground" }, "-"))),
                                        React.createElement(TableCell, null, charge.rateSource || '-'),
                                        React.createElement(TableCell, null, charge.payoutNumber ? (React.createElement(Link, { to: `/payouts/${charge.payoutNumber}`, className: "text-blue-600 hover:underline flex items-center gap-1" },
                                            charge.payoutNumber,
                                            React.createElement(ExternalLink, { className: "h-3 w-3" }))) : charge.approvedPayout ? (`$${charge.approvedPayout.toFixed(2)}`) : ('-')),
                                        React.createElement(TableCell, null, charge.approvedPayoutDate ? (React.createElement("div", { className: "flex flex-col text-sm" }, charge.approvedPayoutDate
                                            .split('\n')
                                            .map((line, i) => (React.createElement("span", { key: i }, line))))) : (React.createElement("span", { className: "text-muted-foreground" }, "-"))),
                                        React.createElement(TableCell, null, charge.payoutStatus ? (React.createElement(Badge, { className: "bg-blue-100 text-blue-800 dark:bg-blue-900 dark:text-blue-200" }, charge.payoutStatus)) : (React.createElement("span", { className: "text-muted-foreground" }, "-"))),
                                        React.createElement(TableCell, null, charge.paidDate || (React.createElement("span", { className: "text-muted-foreground" }, "-"))),
                                        React.createElement(TableCell, null, charge.shipmentId && (React.createElement(Link, { to: `/shipments/${charge.shipmentId}`, className: "text-blue-600 hover:underline" }, charge.shipmentId))),
                                        React.createElement(TableCell, null, charge.equipment ? (React.createElement("button", { onClick: () => {
                                                setSelectedEquipment(charge.equipment);
                                                setEquipmentModalOpen(true);
                                            }, className: "text-blue-600 hover:underline" }, charge.equipment)) : null),
                                        React.createElement(TableCell, null, charge.id === 6 && (React.createElement("div", { className: "flex items-center justify-end gap-2" },
                                            React.createElement(TooltipProvider, null,
                                                React.createElement(Tooltip, null,
                                                    React.createElement(TooltipTrigger, { asChild: true },
                                                        React.createElement(Button, { variant: "ghost", size: "icon", className: "h-9 w-9 rounded-full bg-blue-50 hover:bg-blue-100 text-blue-600" },
                                                            React.createElement(Pencil, { className: "h-4 w-4" }))),
                                                    React.createElement(TooltipContent, { side: "top", className: "bg-gray-900 text-white" },
                                                        React.createElement("p", null, "Add an adjustment")))),
                                            React.createElement(TooltipProvider, null,
                                                React.createElement(Tooltip, null,
                                                    React.createElement(TooltipTrigger, { asChild: true },
                                                        React.createElement(Button, { variant: "ghost", size: "icon", className: "h-9 w-9 rounded-full bg-green-50 hover:bg-green-100 text-green-600" },
                                                            React.createElement(Check, { className: "h-4 w-4" }))),
                                                    React.createElement(TooltipContent, { side: "top", className: "bg-gray-900 text-white" },
                                                        React.createElement("p", null, "Approve Carrier Cost")))),
                                            React.createElement(TooltipProvider, null,
                                                React.createElement(Tooltip, null,
                                                    React.createElement(TooltipTrigger, { asChild: true },
                                                        React.createElement(Button, { variant: "ghost", size: "icon", className: "h-9 w-9 rounded-full hover:bg-red-50 text-red-600" },
                                                            React.createElement(Trash2, { className: "h-4 w-4" }))),
                                                    React.createElement(TooltipContent, { side: "top", className: "bg-gray-900 text-white" },
                                                        React.createElement("p", null, "Remove Line Item")))))))));
                                }),
                                React.createElement(TableRow, { className: "bg-muted/50 font-semibold" },
                                    (apFilter === 'all' || apFilter === 'unactioned') &&
                                        !allAPChargesActioned && React.createElement(TableCell, null),
                                    React.createElement(TableCell, null, "Total"),
                                    React.createElement(TableCell, { className: "text-right" },
                                        "$",
                                        filteredAPTotal.toFixed(2)),
                                    React.createElement(TableCell, { colSpan: 8 })))),
                        React.createElement("div", { className: "mt-8" },
                            React.createElement("h3", { className: "text-lg font-semibold mb-4" }, "Vendor Charges"),
                            React.createElement(Table, null,
                                React.createElement(TableHeader, null,
                                    React.createElement(TableRow, null,
                                        React.createElement(TableHead, null, "Charge"),
                                        React.createElement(TableHead, null, "Cost"),
                                        React.createElement(TableHead, null, "Entered Date"),
                                        React.createElement(TableHead, null, "Paid"),
                                        React.createElement(TableHead, null, "Vendor"))),
                                React.createElement(TableBody, null,
                                    vendorCharges.map((charge) => (React.createElement(TableRow, { key: charge.id },
                                        React.createElement(TableCell, null, charge.charge),
                                        React.createElement(TableCell, null,
                                            "$",
                                            charge.cost.toFixed(2)),
                                        React.createElement(TableCell, null, charge.enteredDate),
                                        React.createElement(TableCell, null,
                                            React.createElement(Checkbox, { checked: charge.paid, disabled: true })),
                                        React.createElement(TableCell, null, charge.vendor)))),
                                    React.createElement(TableRow, { className: "bg-muted/50 font-semibold" },
                                        React.createElement(TableCell, null, "Total"),
                                        React.createElement(TableCell, null,
                                            "$",
                                            vendorCharges
                                                .reduce((sum, charge) => sum + charge.cost, 0)
                                                .toFixed(2)),
                                        React.createElement(TableCell, null),
                                        React.createElement(TableCell, null),
                                        React.createElement(TableCell, null)))))))))),
        React.createElement(Dialog, { open: invoiceModalOpen, onOpenChange: setInvoiceModalOpen },
            React.createElement(DialogContent, { className: "max-w-5xl max-h-[90vh] overflow-y-auto" },
                React.createElement(DialogHeader, null,
                    React.createElement("div", { className: "flex items-center justify-between" },
                        React.createElement(DialogTitle, { className: "text-xl font-semibold" }, "Generate Invoice"),
                        React.createElement(Button, { variant: "ghost", size: "sm", className: "h-8 w-8 p-0", onClick: () => setInvoiceModalOpen(false) },
                            React.createElement(X, { className: "h-4 w-4" })))),
                React.createElement("div", { className: "space-y-4 mt-4" },
                    React.createElement("div", { className: "bg-blue-50 dark:bg-blue-950 border border-blue-200 dark:border-blue-800 rounded-lg p-4" },
                        React.createElement("div", { className: "flex items-start gap-3" },
                            React.createElement(Info, { className: "h-5 w-5 text-blue-600 dark:text-blue-400 flex-shrink-0 mt-0.5" }),
                            React.createElement("div", null,
                                React.createElement("h3", { className: "font-semibold text-blue-900 dark:text-blue-100" }, "Shipper Invoice Grouping Configuration"),
                                React.createElement("p", { className: "text-sm text-blue-700 dark:text-green-300" }, "One Invoice per Shipment per Charge Type")))),
                    React.createElement("div", { className: "bg-green-50 dark:bg-green-950 border border-green-200 dark:border-green-800 rounded-lg p-4" },
                        React.createElement("div", { className: "flex items-start justify-between" },
                            React.createElement("div", { className: "flex items-start gap-3" },
                                React.createElement(CheckCircle, { className: "h-5 w-5 text-green-600 dark:text-green-400 flex-shrink-0 mt-0.5" }),
                                React.createElement("div", null,
                                    React.createElement("h3", { className: "font-semibold text-green-900 dark:text-green-100" }, "Charges Valid For Invoicing"),
                                    React.createElement("p", { className: "text-sm text-green-700 dark:text-green-300" }, "All Selected Charges Valid For Invoicing"))),
                            React.createElement(Button, { variant: "ghost", size: "sm", className: "h-6 w-6 p-0 text-green-600 hover:text-green-700" },
                                React.createElement(X, { className: "h-4 w-4" })))),
                    React.createElement("div", { className: "flex items-center justify-between py-2" },
                        React.createElement("label", { htmlFor: "group-charges", className: "text-base font-medium" }, "Group Related Charges"),
                        React.createElement(Switch, { id: "group-charges", checked: groupRelatedCharges, onCheckedChange: setGroupRelatedCharges })),
                    React.createElement("div", { className: "border rounded-lg divide-y" },
                        React.createElement("div", { className: "bg-muted/50 px-4 py-3" },
                            React.createElement("h3", { className: "font-semibold text-lg" }, "ORD5678")),
                        getOrderLevelCharges().map((charge) => {
                            const sectionId = charge.chargeName
                                .toLowerCase()
                                .replace(/\s+/g, '-');
                            const isExpanded = expandedSections.has(sectionId);
                            return (React.createElement("div", { key: charge.id, className: "border-b last:border-b-0" },
                                React.createElement("button", { className: "w-full px-4 py-3 flex items-center justify-between hover:bg-muted/50 transition-colors", onClick: () => toggleSection(sectionId) },
                                    React.createElement("span", { className: "font-medium" }, charge.chargeName),
                                    isExpanded ? (React.createElement(ChevronUp, { className: "h-5 w-5 text-muted-foreground" })) : (React.createElement(ChevronDown, { className: "h-5 w-5 text-muted-foreground" }))),
                                isExpanded && (React.createElement("div", { className: "px-4 pb-4" },
                                    React.createElement("div", { className: "bg-muted/30 rounded-lg overflow-hidden" },
                                        React.createElement(Table, null,
                                            React.createElement(TableHeader, null,
                                                React.createElement(TableRow, { className: "bg-muted/50" },
                                                    React.createElement(TableHead, { className: "w-12" },
                                                        React.createElement(Checkbox, { checked: true, disabled: true })),
                                                    React.createElement(TableHead, null, "Name"),
                                                    React.createElement(TableHead, { className: "text-right" }, "Amount"),
                                                    React.createElement(TableHead, { className: "text-right pr-6" }, "Group Related Charges?"))),
                                            React.createElement(TableBody, null,
                                                React.createElement(TableRow, null,
                                                    React.createElement(TableCell, null,
                                                        React.createElement(Checkbox, { checked: true, disabled: true })),
                                                    React.createElement(TableCell, null,
                                                        React.createElement("div", { className: "flex items-center gap-2" },
                                                            React.createElement("span", null, charge.chargeName),
                                                            charge.equipment && (React.createElement("span", { className: "text-muted-foreground" }, charge.equipment)))),
                                                    React.createElement(TableCell, { className: "text-right font-medium" },
                                                        "$",
                                                        charge.fee.toFixed(2)),
                                                    React.createElement(TableCell, { className: "text-right pr-6" })),
                                                React.createElement(TableRow, { className: "bg-muted/50 font-semibold" },
                                                    React.createElement(TableCell, { colSpan: 2 }, "Total"),
                                                    React.createElement(TableCell, { className: "text-right" },
                                                        "$",
                                                        charge.fee.toFixed(2)),
                                                    React.createElement(TableCell, null)))))))));
                        }),
                        Object.entries(getShipmentChargesByShipment()).map(([shipmentId, charges]) => {
                            const isExpanded = expandedSections.has(shipmentId);
                            const shipmentTotal = charges.reduce((sum, charge) => sum + charge.fee, 0);
                            return (React.createElement("div", { key: shipmentId, className: "border-b last:border-b-0" },
                                React.createElement("button", { className: "w-full px-4 py-3 flex items-center justify-between hover:bg-muted/50 transition-colors", onClick: () => toggleSection(shipmentId) },
                                    React.createElement("span", { className: "font-semibold" }, shipmentId),
                                    isExpanded ? (React.createElement(ChevronUp, { className: "h-5 w-5 text-muted-foreground" })) : (React.createElement(ChevronDown, { className: "h-5 w-5 text-muted-foreground" }))),
                                isExpanded && (React.createElement("div", { className: "px-4 pb-4" },
                                    React.createElement("div", { className: "bg-muted/30 rounded-lg overflow-hidden" },
                                        React.createElement(Table, null,
                                            React.createElement(TableHeader, null,
                                                React.createElement(TableRow, { className: "bg-muted/50" },
                                                    React.createElement(TableHead, { className: "w-12" },
                                                        React.createElement(Checkbox, { checked: true, disabled: true })),
                                                    React.createElement(TableHead, null, "Name"),
                                                    React.createElement(TableHead, { className: "text-right" }, "Amount"),
                                                    React.createElement(TableHead, { className: "text-right pr-6" }, "Group Related Charges?"))),
                                            React.createElement(TableBody, null,
                                                charges.map((charge) => (React.createElement(TableRow, { key: charge.id },
                                                    React.createElement(TableCell, null,
                                                        React.createElement(Checkbox, { checked: true, disabled: true })),
                                                    React.createElement(TableCell, null,
                                                        React.createElement("div", { className: "flex items-center gap-2" },
                                                            React.createElement("span", null, charge.chargeName),
                                                            charge.equipment && (React.createElement("span", { className: "text-muted-foreground" }, charge.equipment)))),
                                                    React.createElement(TableCell, { className: "text-right font-medium" },
                                                        "$",
                                                        charge.fee.toFixed(2)),
                                                    React.createElement(TableCell, { className: "text-right pr-6" })))),
                                                React.createElement(TableRow, { className: "bg-muted/50 font-semibold" },
                                                    React.createElement(TableCell, { colSpan: 2 }, "Total"),
                                                    React.createElement(TableCell, { className: "text-right" },
                                                        "$",
                                                        shipmentTotal.toFixed(2)),
                                                    React.createElement(TableCell, null)))))))));
                        })),
                    React.createElement("div", { className: "flex items-center justify-between pt-4 border-t" },
                        React.createElement("div", { className: "text-lg font-semibold" },
                            "Grand Total: $",
                            calculateGrandTotal().toFixed(2)),
                        React.createElement("div", { className: "flex items-center gap-3" },
                            React.createElement(Button, { variant: "outline", onClick: () => setInvoiceModalOpen(false) }, "Cancel"),
                            React.createElement(Button, { variant: "outline", className: "bg-green-600 text-white hover:bg-green-700 border-green-600", onClick: () => {
                                    console.log('[v0] Generating no delivery invoice');
                                    setInvoiceModalOpen(false);
                                } }, "Generate No Delivery Invoice"),
                            React.createElement(Button, { className: "bg-green-600 text-white hover:bg-green-700", onClick: () => {
                                    console.log('[v0] Generating invoice');
                                    setInvoiceModalOpen(false);
                                } }, "Generate Invoice")))))),
        React.createElement(Dialog, { open: rerateModalOpen, onOpenChange: setRerateModalOpen },
            React.createElement(DialogContent, { className: "max-w-2xl" },
                React.createElement(DialogHeader, null,
                    React.createElement(DialogTitle, { className: "text-xl font-semibold" }, "Rerate Order")),
                React.createElement("div", { className: "space-y-6 mt-6" },
                    React.createElement("h3", { className: "text-lg font-semibold" }, "Select which line items to rerate"),
                    React.createElement("div", { className: "space-y-4" },
                        React.createElement("div", { className: "flex items-center gap-3" },
                            React.createElement(Checkbox, { id: "shipper-base-cost", checked: rerateSelections.shipperBaseCost, onCheckedChange: (checked) => setRerateSelections((prev) => (Object.assign(Object.assign({}, prev), { shipperBaseCost: checked }))) }),
                            React.createElement("label", { htmlFor: "shipper-base-cost", className: "text-base font-medium cursor-pointer" }, "Shipper Base Cost")),
                        React.createElement("div", { className: "flex items-center gap-3" },
                            React.createElement(Checkbox, { id: "carrier-base-cost", checked: rerateSelections.carrierBaseCost, onCheckedChange: (checked) => setRerateSelections((prev) => (Object.assign(Object.assign({}, prev), { carrierBaseCost: checked }))) }),
                            React.createElement("label", { htmlFor: "carrier-base-cost", className: "text-base font-medium cursor-pointer" }, "Carrier Base Cost")),
                        React.createElement("div", { className: "flex items-center gap-3" },
                            React.createElement(Checkbox, { id: "carrier-fuel-surcharge", checked: rerateSelections.carrierFuelSurcharge, onCheckedChange: (checked) => setRerateSelections((prev) => (Object.assign(Object.assign({}, prev), { carrierFuelSurcharge: checked }))) }),
                            React.createElement("label", { htmlFor: "carrier-fuel-surcharge", className: "text-base font-medium cursor-pointer" }, "Carrier Fuel Surcharge")),
                        React.createElement("div", { className: "flex items-center gap-3" },
                            React.createElement(Checkbox, { id: "shipper-fuel-surcharge", checked: rerateSelections.shipperFuelSurcharge, onCheckedChange: (checked) => setRerateSelections((prev) => (Object.assign(Object.assign({}, prev), { shipperFuelSurcharge: checked }))) }),
                            React.createElement("label", { htmlFor: "shipper-fuel-surcharge", className: "text-base font-medium cursor-pointer" }, "Shipper Fuel Surcharge"))),
                    React.createElement("div", { className: "flex items-center justify-end gap-3 pt-6" },
                        React.createElement(Button, { variant: "outline", onClick: () => setRerateModalOpen(false) }, "Cancel"),
                        React.createElement(Button, { className: "bg-emerald-500 hover:bg-emerald-600 text-white", onClick: () => {
                                console.log('[v0] Rerating with selections:', rerateSelections);
                                setRerateModalOpen(false);
                            } }, "Rerate"))))),
        React.createElement(Dialog, { open: pastDueEmailModalOpen, onOpenChange: setPastDueEmailModalOpen },
            React.createElement(DialogContent, { className: "max-w-2xl" },
                React.createElement(DialogHeader, null,
                    React.createElement(DialogTitle, { className: "text-xl font-semibold" }, "Send Fees Due Payment Link")),
                React.createElement("div", { className: "space-y-6 mt-6" },
                    React.createElement("div", null,
                        React.createElement("div", { className: "flex items-center gap-2 mb-2" },
                            React.createElement("label", { htmlFor: "recipients", className: "text-base font-medium" }, "Recipients"),
                            React.createElement(Info, { className: "h-4 w-4 text-muted-foreground" })),
                        React.createElement("input", { id: "recipients", type: "text", placeholder: "Comma separated email addresses", value: emailRecipients, onChange: (e) => setEmailRecipients(e.target.value), className: "w-full px-3 py-2 border border-input rounded-md bg-background focus:outline-none focus:ring-2 focus:ring-ring" })),
                    React.createElement("div", { className: "flex items-center justify-end gap-3 pt-6" },
                        React.createElement(Button, { variant: "outline", className: "bg-red-500 hover:bg-red-600 text-white border-red-500", onClick: () => {
                                setPastDueEmailModalOpen(false);
                                setEmailRecipients('');
                            } }, "Close"),
                        React.createElement(Button, { variant: "outline", className: "text-green-600 border-green-600 hover:bg-green-50 bg-transparent", disabled: !emailRecipients.trim(), onClick: () => {
                                console.log('[v0] Sending past due email to:', emailRecipients);
                                setPastDueEmailModalOpen(false);
                                setEmailRecipients('');
                            } }, "Send"))))),
        React.createElement(Dialog, { open: shipperCostModalOpen, onOpenChange: setShipperCostModalOpen },
            React.createElement(DialogContent, { className: "max-w-3xl" },
                React.createElement(DialogHeader, null,
                    React.createElement("div", { className: "flex items-center justify-between" },
                        React.createElement(DialogTitle, { className: "text-2xl font-semibold text-gray-700" }, "Shipper Cost Adjustment"),
                        React.createElement(Button, { variant: "ghost", size: "sm", className: "h-8 w-8 p-0", onClick: () => setShipperCostModalOpen(false) },
                            React.createElement(X, { className: "h-4 w-4" })))),
                React.createElement("div", { className: "grid grid-cols-2 gap-6 mt-6" },
                    React.createElement("div", null,
                        React.createElement("div", { className: "flex items-center gap-2 mb-2" },
                            React.createElement("label", { htmlFor: "shipper-cost-value", className: "text-base font-semibold" }, "Add Shipper cost value"),
                            React.createElement(Tooltip, null,
                                React.createElement(TooltipTrigger, { asChild: true },
                                    React.createElement(Info, { className: "h-4 w-4 text-muted-foreground cursor-help" })),
                                React.createElement(TooltipContent, null,
                                    React.createElement("p", null, "Enter the new shipper cost value")))),
                        React.createElement("input", { id: "shipper-cost-value", type: "text", value: shipperCostValue, onChange: (e) => setShipperCostValue(e.target.value), className: "w-full px-4 py-2 border border-input rounded-md bg-background focus:outline-none focus:ring-2 focus:ring-ring text-lg" })),
                    React.createElement("div", null,
                        React.createElement("label", { htmlFor: "equipment", className: "text-base font-semibold mb-2 block" }, "Equipment"),
                        React.createElement(Select, { value: shipperCostEquipment, onValueChange: setShipperCostEquipment },
                            React.createElement(SelectTrigger, { id: "equipment", className: "w-full" },
                                React.createElement(SelectValue, null)),
                            React.createElement(SelectContent, null,
                                React.createElement(SelectItem, { value: "CMAU6148772" }, "CMAU6148772"),
                                React.createElement(SelectItem, { value: "CONT-1234" }, "CONT-1234"),
                                React.createElement(SelectItem, { value: "CONT-5678" }, "CONT-5678")))),
                    React.createElement("div", null,
                        React.createElement("label", { htmlFor: "reason-code", className: "text-base font-semibold mb-2 block" }, "Reason Code"),
                        React.createElement(Select, { value: shipperCostReasonCode, onValueChange: (value) => {
                                setShipperCostReasonCode(value);
                                setShipperCostErrors((prev) => (Object.assign(Object.assign({}, prev), { reasonCode: false })));
                            } },
                            React.createElement(SelectTrigger, { id: "reason-code", className: "w-full" },
                                React.createElement(SelectValue, { placeholder: "Select" })),
                            React.createElement(SelectContent, null,
                                React.createElement(SelectItem, { value: "select" },
                                    React.createElement("div", { className: "flex items-center gap-2" },
                                        React.createElement(CheckCircle, { className: "h-4 w-4 text-blue-600" }),
                                        "Select")),
                                React.createElement(SelectItem, { value: "reason-code" }, "Reason Code"),
                                React.createElement(SelectItem, { value: "rate-error" }, "Rate Error"),
                                React.createElement(SelectItem, { value: "fuel-error" }, "Fuel Error"),
                                React.createElement(SelectItem, { value: "btf-error" }, "BTF Error"),
                                React.createElement(SelectItem, { value: "accessorial-error" }, "Accessorial Error"),
                                React.createElement(SelectItem, { value: "customer-accommodation" }, "Customer Accommodation"),
                                React.createElement(SelectItem, { value: "missing-documentation" }, "Missing Documentation"),
                                React.createElement(SelectItem, { value: "missing-approvals" }, "Missing Approvals"),
                                React.createElement(SelectItem, { value: "duplicate-invoice" }, "Duplicate Invoice"))),
                        shipperCostErrors.reasonCode && (React.createElement("p", { className: "text-red-500 text-sm italic mt-1" }, "Reason Code is required"))),
                    React.createElement("div", null,
                        React.createElement("label", { htmlFor: "enter-note", className: "text-base font-semibold mb-2 block" }, "Enter Note"),
                        React.createElement("textarea", { id: "enter-note", value: shipperCostNotes, onChange: (e) => {
                                setShipperCostNotes(e.target.value);
                                setShipperCostErrors((prev) => (Object.assign(Object.assign({}, prev), { notes: false })));
                            }, placeholder: "Enter Notes here...", rows: 3, className: "w-full px-4 py-2 border border-input rounded-md bg-background focus:outline-none focus:ring-2 focus:ring-ring resize-none" }),
                        shipperCostErrors.notes && (React.createElement("p", { className: "text-red-500 text-sm italic mt-1" }, "Notes cannot be empty")))),
                React.createElement("div", { className: "flex items-center justify-start gap-3 pt-6 mt-6 border-t" },
                    React.createElement(Button, { className: "bg-green-600 hover:bg-green-700 text-white px-6", onClick: () => {
                            const errors = {
                                reasonCode: !shipperCostReasonCode ||
                                    shipperCostReasonCode === 'select',
                                notes: !shipperCostNotes.trim(),
                            };
                            setShipperCostErrors(errors);
                            if (!errors.reasonCode && !errors.notes) {
                                console.log('[v0] Saving shipper cost adjustment:', {
                                    value: shipperCostValue,
                                    equipment: shipperCostEquipment,
                                    reasonCode: shipperCostReasonCode,
                                    notes: shipperCostNotes,
                                });
                                setShipperCostModalOpen(false);
                            }
                        } }, "Save"),
                    React.createElement(Button, { variant: "outline", onClick: () => setShipperCostModalOpen(false) }, "Cancel"))))));
}
